<template>
  <v-card max-width="800px" class="mx-auto mt-4 overflow-hidden">

    <v-navigation-drawer
    v-model="filterDrawer"
    fixed
    stateless
    class="foreground"
    >

      <v-card class="">
        <v-layout justify-center align-center class="backgroundCard pa-2">
          <v-btn outlined small @click="clearFilters" :disabled="activeFilterCount === 0">
            Clear
          </v-btn>
          <v-spacer></v-spacer>
          <template>
            <div class="ml-1">
              Filter
            </div>
            <span v-if="activeFilterCount > 0">
              &nbsp;|&nbsp;
              <span class="color1--text">
                {{ activeFilterCount }}
              </span>
            </span>
          </template>
          <v-spacer></v-spacer>
          <v-btn icon color="color1" class="white--text" small @click="filterDrawer = false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-layout>
        <div class="c-hr"></div>
        <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.customer = !filters.active.customer">
          <v-icon small v-if="filters.active.customer" color="color1">
            mdi-checkbox-marked-outline
          </v-icon>
          <v-icon small v-else>
            mdi-checkbox-blank-outline
          </v-icon>
          &nbsp;
          Customer:
        </v-layout>
        <div class="c-hr"></div>
        <v-expand-transition>
          <div v-show="filters.active.customer">
            <div class="pt-1 pb-1 background">
            </div>
          </div>
        </v-expand-transition>

        <div class="c-hr"></div>
        <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
          <v-icon small v-if="filters.active.date" color="color1">
            mdi-checkbox-marked-outline
          </v-icon>
          <v-icon small v-else>
            mdi-checkbox-blank-outline
          </v-icon>
          &nbsp;
          Date:
        </v-layout>
        <div class="c-hr"></div>
        <v-expand-transition>
          <div v-show="filters.active.date">
            <div class="background pt-1 pb-1">
              <v-select
                v-model="filters.date.mainSelect"
                class="ma-2 input-slot-thin-border caption"
                :items="dateFilters"
                dense
                hide-details
                solo
              ></v-select>
              <!-- DATE OPTIONS -->
              <div v-if="filters.date.mainSelect === 'is in the last'">
                <v-layout class="pl-2 pr-2" style="width: 12em;">
                    <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                    &nbsp;
                    <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>

                    <v-select
                      v-model="filters.date.isInTheLast_select"
                      class="input-slot-thin-border caption"
                      style="flex: 0 0 5em;"
                      :items="['days', 'months']"
                      dense
                      hide-details
                      solo
                    ></v-select>
                
                </v-layout>
              </div>
              <div v-else-if="filters.date.mainSelect === 'is equal to'">
                <v-layout class="pl-2 pr-2" align-center>
                  <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                  &nbsp;
                  <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                </v-layout>
              </div>
              <div v-else-if="filters.date.mainSelect === 'is between'">
                <v-layout class="pl-2 pr-2" align-center>
                  <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                  &nbsp;
                  <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                  and
                  <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                </v-layout>
              </div>
              <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                <v-layout class="pl-2 pr-2" align-center>
                  <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                  &nbsp;
                  <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                </v-layout>
              </div>
              <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                <v-layout class="pl-2 pr-2" align-center>
                  <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                  &nbsp;
                  <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                </v-layout>
              </div>
              <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                <v-layout class="pl-2 pr-2" align-center>
                  <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                  &nbsp;
                  <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                </v-layout>
              </div>
              <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                <v-layout class="pl-2 pr-2" align-center>
                  <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                  &nbsp;
                  <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                </v-layout>
              </div>
              
            </div>
          </div>
        </v-expand-transition>
      </v-card>

    </v-navigation-drawer>

    <div>
      <!-- main toolbar -->
      <div>
        <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

          <transition
          name="slide-x-reverse-transition"
          mode="out-in">

            <!-- ITEMS -->
            <div 
            v-if="selectedCount === 0"
            key="1"
            class="c-flex-r align-center subheading">

              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
              text
              outlined
              class="mr-2"
              @click="newDelivery">
                <v-icon>add</v-icon>
                <div class="ml-1">
                  New delivery
                </div>
              </v-btn>

              <v-btn
                text
                outlined
                @click="filterDrawer = !filterDrawer"
              >
                <v-icon small>mdi-filter</v-icon>
                <div class="ml-1">
                  Filter
                </div>
                <span v-if="activeFilterCount > 0">
                  &nbsp;|&nbsp;
                  <span class="color1--text">
                    {{ activeFilterCount }}
                  </span>
                </span>
              </v-btn>

            </div>

            <!-- selected count -->
            <div v-if="selectedCount > 0"
            key="2"
            class="c-flex-r align-center subheading">
              <v-btn
              icon
              class=""
              @click="selected = {}">
                <v-icon>close</v-icon>
              </v-btn>
              <div class="text-sans font-weight-bold">
                <span>&nbsp;{{ selectedCount }}</span>
                selected 
              </div>
              <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
              <span class="ml-2">|</span>
              <v-btn 
              icon
              @click="onDelete">
                <v-icon>delete_outline</v-icon>
              </v-btn>
              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectNone">
                    <v-list-item-title>Select none</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

          </transition>

          <v-spacer></v-spacer>

          <div>
            <transition
            name="fade-transition"
            mode="out-in">
              <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
                <span class="grey--text caption">LOADING...</span>&nbsp;
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-layout>
              <div v-else key="L2"></div>
            </transition>
          </div>

        </v-row>
      </div>
      <!-- !main toolbar -->

    </div>

    <table class="final-table full-width lines-b no-padding">
      <colgroup>
        <col width="200px">
        <col width="200px">
        <col width="200px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="ID"
        code="id"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Items"
        code="items"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Date"
        code="date"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
  
      </tr>

      <tr class="unselectable">
        <td style="padding: 8px 12px 8px 16px;">
          <v-text-field
          v-model="filters.search.id"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo></v-text-field>
        </td>
        <td>
          
        </td>
        <td>
          
        </td>
      </tr>

    </table>

    <div class="c-hr"></div>

    <v-layout class="align-center">
      <div class="pa-4 label">
        {{ pagination.rowCount }} items
      </div>

      <v-spacer></v-spacer>

      <div class="mr-4">

        <v-tooltip top open-delay="300">
          <template v-slot:activator="{ on }">
            <v-btn
            v-on="on"
            icon
            small
            color="color1"
            :disabled="page <= 0"
            @click="goToPreviousPage()"
            class=""
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>Previous page</span>
        </v-tooltip>

        <v-tooltip top open-delay="300">
          <template v-slot:activator="{ on }">
            <v-btn
            v-on="on"
            icon
            small
            color="color1"
            :disabled="page >= pagination.pages - 1"
            @click="goToNextPage()"
            class=""
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>Next page</span>
        </v-tooltip>

      </div>
    </v-layout>

    <table class="final-table pointer hover full-width">
      <colgroup ref="colgroup2">
        <col width="200px">
        <col width="200px">
        <col width="200px">
      </colgroup>

      <list-row
      v-for="item in items" 
      vmode="table"
      :key="item.id"
      :item="item"
      :itemsMeta="itemsMeta"
      :selected="selected"
      :searchFilters="filters.search"
      @checkRow="checkRow(item)"
      @click.native="clickRow(item)"
      ></list-row>

    </table>

    <!-- No sales -->
    <v-card v-if="items.length === 0" class="pa-2 ma-4 subheading elevation-0">
      <v-layout v-if="searchIsActive" align-center>
        <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
        <div class="ml-2 mr-2">
          <v-layout align-center>
            <span>
              No items match your search
            </span>
            <v-icon large color="red accent-4">search</v-icon>
          </v-layout>

          <div class="caption text--text text--darken-1">
            clear search
          </div>
        </div>
      </v-layout>
      <v-layout v-else-if="activeFilterCount > 0" align-center>
        <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
        <div class="ml-2 mr-2">
          <v-layout align-center>
            <span>
              No items match your filters
            </span>
            <v-icon large color="red accent-4">search</v-icon>
          </v-layout>

          <div class="caption text--text text--darken-1">
            clear filters
          </div>
        </div>
      </v-layout>
      <v-layout v-else align-center>
        <img src="@/assets/img/illustrations/package.png" alt="cardboard box" width="36px">
        <div class="ml-2 mr-2">
          <v-layout align-center>
            <span>
              0 deliveries in process
            </span>
            <v-icon large color="green accent-4">check</v-icon>
          </v-layout>

          <div class="caption text--text text--darken-1">
            Deliveries in process will be listed here
          </div>
        </div>
      </v-layout>
    </v-card>

    <!-- BOTTOM TOOLBAR -->
    <v-layout align-center class="border-t--thin">
      <!-- PAGINATION -->
      <c-pagination
      :page="page"
      :pagination="pagination"
      :filters="filters"
      @updatePageNumber="updatePageNumber"
      @goToFirstPage="goToFirstPage"
      @goToPreviousPage="goToPreviousPage"
      @goToNextPage="goToNextPage"
      @goToLastPage="goToLastPage"
      ></c-pagination>
      <!-- PAGINATION -->
    </v-layout>
    <!-- !BOTTOM TOOLBAR -->

  </v-card>
</template>

<script>
import axios from 'axios'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import ListRow from './components/delivery-list-row'
import _ from 'lodash'

export default {
  components: {
    ListRow
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 5,
        sortCol: 'date',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
        },
        active: {
          customer: false,
          date: false
        }
      },
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
      itemsMeta: {
        newID: null // this will be set to the newst created row
      },
      filterDrawer: false,
      isLoading: false
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push(`/delivery/${item.id}`)
      }
    },
    newDelivery () {
      this.$axios.post('deliveries/create',
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          this.itemsMeta.newID = response.data.id
          console.log(this.itemsMeta.newID)
          this.page = 0
          this.filters.sortCol = 'id'
          this.filters.sortAscending = false
          Object.keys(this.filters.active).forEach(key => {
            this.filters.active[key] = false
          })
          Object.keys(this.filters.search).forEach(key => {
            this.filters.search[key] = ''
          })
          this.loadAPI()
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' quote' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('deliveries/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.page = 0
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    debounceLoad: _.debounce(function (e) {
      console.log('LOADING API')
      // this.pushFiltersToRoute()
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/deliveries?filters=${encodedFilters}&page=${this.page}&completed=0`)
        ])
        .then(axios.spread((response) => {
          var rows = response.data.rows
          this.pagination.rowCount = response.data.count
          this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
          this.items = rows
        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
    loadAPI () {
      return this.debounceLoad()
    }
  },
  created () {
    // activated works more effectively in keep-alive components
    /* this.page = Number(this.$route.query.page) || 0
    var filters = JSON.parse(JSON.stringify(this.filters))
    this.rightSideMerge(filters, this.decodedUrl)
    this.setFiltersWithoutTriggeringWatcher(filters) */
    this.loadAPI()
  },
  activated () {
    this.loadAPI()
  }
}
</script>